import { useTheme } from '../context/ThemeContext';

// Logo URLs
const LOGO_ICON = "/images/logos/logo-color.png";
const LOGO_DARK_FULL = "/images/logos/logo-white.png";

export function Logo({ className = "h-10" }) {
  const { theme } = useTheme();
  
  return (
    <img 
      src={theme === 'dark' ? LOGO_DARK_FULL : LOGO_ICON} 
      alt="Axeris Labs" 
      className={`${className} w-auto object-contain`}
    />
  );
}
